import React, { useState, useEffect } from "react";

import { FaSpinner } from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";


import {
  FaComments,
  FaIdCard,
  FaHome,
  FaBook,
  FaFlask,
  FaBullhorn,
  FaCalendarAlt,
  FaEnvelope,
  FaEdit,
  FaSignOutAlt,
  FaEye,
  FaChalkboardTeacher,
  FaBusinessTime,
  FaQuestion,
} from "react-icons/fa";
import { MdAssignment } from "react-icons/md";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  useTheme,
  useMediaQuery,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";

const drawerWidth = 240;


const iconMap = {
  Dashboard: <FaHome />,
  Assignment: <FaEdit />,
  Attendance: <FaCalendarAlt />,
  Examination: <FaCalendarAlt />,
  "Study Material": <FaBook />,
  Lesson: <FaBook />,
  Topic: <FaBook />,
  Logout: <FaSignOutAlt />,
  "Assignment Create": <FaBook />,
  assignmentview: <MdAssignment />,
  Exam: <FaEnvelope />,
  "View Announcements": <FaEye />,
  "Classroom Management": <FaChalkboardTeacher />,
  "Time Table": <FaBusinessTime />,
  "Student Details": <FaIdCard />,
  "Chat App": <FaComments />,
  "View Admit Card": <FaIdCard />,
};
const loaderStyles = {
  listStyle: "none",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "8px 12px",
  color: "white",
  fontSize: "0.9rem",
};

function TeacherSidebar({ onSelect, mobileOpen = false, onDrawerToggle }) {
  const location = useLocation(); // top-level (outside component)

  const [menuItems, setMenuItems] = useState([]);
  const [expandedItems, setExpandedItems] = useState({});
  const [submenuItems, setSubmenuItems] = useState({});
  const [loadingSubmenu, setLoadingSubmenu] = useState({});

  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const logo = sessionStorage.getItem("clientLogo");
  const OrgName = sessionStorage
    .getItem("organizationName")
    ?.replace(/['"]+/g, "") || "School";

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch(
          "https://wsmsv1.aidigitalsec.com/api/ExclusivePermission/Module",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: sessionStorage.getItem("token"),
            },
            body: JSON.stringify({}),
          }
        );
        const data = await response.json();
        const sortedData = data.sort(
          (a, b) => a.moduleSequence - b.moduleSequence
        );
        setMenuItems(sortedData);

        const initialExpandedItems = {};
        sortedData.forEach((item) => {
          initialExpandedItems[item.moduleId] = false;
        });
        setExpandedItems(initialExpandedItems);
      } catch (error) {
        console.error("Error fetching menu items:", error);
      }
    };

    fetchMenuItems();
  }, []);

  const handleToggle = async (id) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));

    if (!expandedItems[id]) {
  try {
    // 🔄 loader ON
    setLoadingSubmenu((prev) => ({ ...prev, [id]: true }));

    const response = await fetch(
      "https://wsmsv1.aidigitalsec.com/api/ExclusivePermission/Form_Authorizer",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: sessionStorage.getItem("token"),
        },
        body: JSON.stringify({ moduleId: id }),
      }
    );

    const data = await response.json();

    setSubmenuItems((prev) => ({
      ...prev,
      [id]: data,
    }));
  } catch (error) {
    console.error("Error fetching submenu items:", error);
  } finally {
    // ✅ loader OFF
    setLoadingSubmenu((prev) => ({ ...prev, [id]: false }));
  }
}

  };

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    sessionStorage.clear();
    navigate("/");
    setShowLogoutModal(false);
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleDrawerToggle = () => {
    if (onDrawerToggle) {
      onDrawerToggle();
    }
  };

  const drawerContent = (
  <Box
    sx={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",



    }}
  >
    {/* Header */}
   <Box
  sx={{
    height: 72,                     // ✅ NEW (fixed height)
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    gap: 1.2,                       // 🔄 slight spacing tweak
    px: 2,                          // 🔄 p → px (vertical height fixed)
    borderBottom: "1px solid rgba(255,255,255,0.2)",
    backgroundColor: "rgba(0,0,0,0.18)",
    backdropFilter: "blur(14px)",
  }}
>

      <Avatar
        alt={OrgName}
        src={`https://wsmsv1.aidigitalsec.com${logo?.replace("~", "") || ""}`}
        sx={{
          width: 44,
          height: 44,
          flexShrink: 0,
          border: "1px solid rgba(255,255,255,0.35)",
          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
        }}
      />
<Typography
  sx={{
    color: "white",
    fontWeight: 600,
    fontSize: "0.95rem",
    letterSpacing: "0.2px",
    lineHeight: 1,              // ✅ fixed line height
    whiteSpace: "nowrap",       // ✅ SAME LINE only
    overflow: "hidden",         // ✅ cut extra text
    textOverflow: "ellipsis",   // ✅ ... show
    maxWidth: 180,              // ✅ control width (adjust if needed)
  }}
>
  {OrgName}
</Typography>


    </Box>

    <Divider sx={{ borderColor: "rgba(255,255,255,0.2)" }} />

    {/* Menu List */}
    <List
      sx={{
        px: 1,
        flexGrow: 1,
        overflowY: "auto",
        maxHeight: "100%",
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(255,255,255,0.65) transparent",
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-track": { background: "transparent" },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(255,255,255,0.55)",
          borderRadius: "16px",
          minHeight: "60px",
        },
        "&::-webkit-scrollbar-thumb:hover": {
          backgroundColor: "rgba(255,255,255,0.85)",
        },
        "& .MuiListItemButton-root": {
          borderRadius: 8,
          mx: 0.5,
          my: 0.25,
          color: "white",
          transition: "background-color 0.2s ease",
          "&:hover": {
  backgroundColor: "rgba(0,0,0,0.18)",
},

          "&.Mui-selected": { backgroundColor: "rgba(255,255,255,0.32)" },
        },
        "& .MuiListItemIcon-root": { minWidth: 38, color: "white" },
        "& .MuiListItemText-primary": {
          fontSize: "0.95rem",
          fontWeight: 500,
          color: "white",
        },
      }}
    >
      {/* Dashboard */}
      <ListItem disablePadding>
        <ListItemButton
          component={Link}
          to="/teachersDashboard"
          onClick={() => {
            onSelect("Dashboard");
            if (isMobile) handleDrawerToggle();
          }}
          sx={{ borderRadius: 1 }}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            <FaHome style={{ fontSize: 20, color: "white" }} />
          </ListItemIcon>
          <ListItemText primary="Dashboard" />
        </ListItemButton>
      </ListItem>

      {/* Dynamic Menu Items */}
      {menuItems.map((menuItem) => (
        <React.Fragment key={menuItem.moduleId}>
          <ListItem disablePadding>
            <ListItemButton
              onClick={() => handleToggle(menuItem.moduleId)}
              sx={{ borderRadius: 1 }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                {iconMap[menuItem.moduleName] ? (
                  React.cloneElement(iconMap[menuItem.moduleName], {
                    style: { fontSize: 20, color: "white" },
                  })
                ) : (
                  <FaQuestion style={{ fontSize: 20, color: "white" }} />
                )}
              </ListItemIcon>
              <ListItemText primary={menuItem.moduleName} />
              {expandedItems[menuItem.moduleId] ? (
                <ExpandLess sx={{ fontSize: 18, color: "white" }} />
              ) : (
                <ExpandMore sx={{ fontSize: 18, color: "white" }} />
              )}
            </ListItemButton>
          </ListItem>
          <Collapse in={expandedItems[menuItem.moduleId]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{ pl: 3 }}>
              {loadingSubmenu[menuItem.moduleId] ? (
                <li style={loaderStyles}>
                  <FaSpinner className="spinner-icon" />
                  <span>Loading...</span>
                </li>
              ) : (
                submenuItems[menuItem.moduleId]?.map((subItem) => (
                  <ListItem key={subItem.formId} disablePadding>
                    <ListItemButton
                      component={Link}
                      to={subItem.formUrl.replace(/^(\.\.\/)+/, "/")}
                      selected={
                        location.pathname ===
                        subItem.formUrl.replace(/^(\.\.\/)+/, "/")
                      }
                      sx={{
                        pl: 2,
                        "&.Mui-selected": {
  backgroundColor: "rgba(0,0,0,0.28)",
  fontWeight: 600,
},

                      }}
                      onClick={() => {
                        onSelect(subItem.formName);
                        if (isMobile) handleDrawerToggle();
                      }}
                    >
                      <ListItemText primary={subItem.formName} />
                    </ListItemButton>
                  </ListItem>
                ))
              )}
            </List>
          </Collapse>
        </React.Fragment>
      ))}
    </List>

    {/* Fixed Logout */}
    <Box
      sx={{
        p: 1,
        borderTop: "1px solid rgba(255,255,255,0.25)",
        flexShrink: 0,
      }}
    >
      <ListItem disablePadding>
        <ListItemButton onClick={handleLogout} sx={{ color: "white" }}>
          <ListItemIcon sx={{ color: "white" }}>
            <FaSignOutAlt />
          </ListItemIcon>
          <ListItemText primary="Logout" />
        </ListItemButton>
      </ListItem>
    </Box>
  </Box>
);


  return (
    <>
      {/* Mobile temporary drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",



            boxShadow: "2px 0 8px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Desktop permanent drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: drawerWidth,
            background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",



            boxShadow: "2px 0 8px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        {drawerContent}
      </Drawer>

      {/* Mobile Toggle Button */}
      {isMobile && !mobileOpen && (
        <Box
          sx={{
            position: "fixed",
            top: 55, // Below navbar
            left: 0,
            zIndex: 1100,
            backgroundColor: "rgba(255, 255, 255, 0.9)",
            backdropFilter: "blur(10px)",
            borderRadius: "0 8px 8px 0",
            p: 1,
          }}
        >
          <Button
            variant="contained"
            startIcon={<MenuIcon />}
            onClick={handleDrawerToggle}
            sx={{
              minWidth: "auto",
              background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",



              color: "white",
              boxShadow: "none",
              "&:hover": {
                background: "linear-gradient(135deg, #fda085 0%, #f6d365 100%)",
              },
            }}
          >
            Menu
          </Button>
        </Box>
      )}

      {/* Logout Dialog */}
      <Dialog
        open={showLogoutModal}
        onClose={cancelLogout}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelLogout} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmLogout} color="error" autoFocus>
            Yes, Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TeacherSidebar;